import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { HowWorksComponent } from './how-works/how-works.component';
import { FeaturesStatusService } from '../shared/services/util/features-status.service';
import { FeatureNames } from '../shared/models/feature-names.enum';

@Component({
    selector: 'app-credit-letter',
    templateUrl: './credit-letter.component.html',
    styleUrls: ['./credit-letter.component.scss']
})
export class CreditLetterComponent implements OnInit {

    public loading: boolean;
    public showBackIcon: boolean = false;
    public userData: any;

    constructor(
        private readonly router: Router,
        private readonly dialog: MatDialog,
        private readonly featuresStatusService: FeaturesStatusService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd || event instanceof NavigationStart) {
                if (this.router.url.substr(-8).match('letter')) {
                    this.router.navigate(['/credit-conversion/panel']);
                }
                if (!this.router.url.substr(-8).match('panel')) {
                    this.showBackIcon = true;
                } else {
                    this.showBackIcon = false;
                }
            }
        });
    }

    public ngOnInit(): void {
        this.featuresStatusService.getFeatureStatus(FeatureNames.LETTER_OF_CREDIT).subscribe((data: boolean) => {
            if (!data) {
                this.router.navigate(['/home']);
            }
        });
    }

    public getLoggedUser(user: any): void {
        this.userData = user;
    }

    public openHowItWorks(): void {
        this.dialog.open(HowWorksComponent, {
            panelClass: 'how-works-modal'
        });
    }
}
